module.exports={
	"Form": "AccountTypeCreateManifest",
	"Scope": "AccountType-Create",
	"Descriptors":
	{
		"AccountTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AccountType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AccountType-Create-Identity",
				"Group": "AccountType-Create-Identity"
			}
		},
		"AccountTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "AccountType-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Create-Details",
				"Group": "AccountType-Create-Details"
			}
		},
		"AccountTypeDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "AccountType-Create-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Create-Details",
				"Group": "AccountType-Create-Details"
			}
		},
		"AccountTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AccountType-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "AccountType-Create-Details",
				"Group": "AccountType-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AccountType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AccountType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AccountType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AccountType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
